import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Primitives";
import { scrollToId } from "@/lib/site";

const LINKS = [
  ["solutions", "Solutions"],
  ["payroll", "Payroll"],
  ["calculator", "Savings"],
  ["review", "Statement review"],
  ["faq", "FAQ"],
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled || open ? "bg-[#F5F6F2]/90 backdrop-blur-xl shadow-[0_1px_0_rgba(11,18,32,0.08)]" : ""
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0 })} data-testid="nav-logo">
          <Logo />
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`nav-link-${id}`}
              className="text-sm font-medium text-slate-700 hover:text-[var(--cobalt)] transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={() => go("quote")}
            data-testid="nav-cta-quote"
            className="group hidden sm:inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-white pl-5 pr-2 py-2 text-sm font-semibold hover:bg-[var(--cobalt)] transition-colors"
          >
            Get my free quote
            <span className="grid place-items-center h-7 w-7 rounded-full bg-white/15 group-hover:rotate-45 transition-transform">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </button>
          <button className="lg:hidden p-2" onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden px-5 pb-6 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {[...LINKS, ["quote", "Get my free quote"]].map(([id, label]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`nav-mobile-link-${id}`}
              className="text-left py-3 font-display text-2xl border-b border-slate-200"
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
